export const COMPACT = 'compact'
export const ENLARGE = 'enlarge'
export const EYE_DROPPER = 'eyeDropper'
export const PLUS = 'plus'
export const SETTINGS = 'settings'
export const TRASH = 'trash'
